window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

import * as Flowbite from 'flowbite';
import $ from "jquery";
window.Flowbite = Flowbite;
window.$ = window.jQuery = $;